const mod = crateImports["@xing-com/crate-communication-tracking"];
const { SCHEMA_VERSION,useTracking,useViewerDataEventual } = mod;
export { SCHEMA_VERSION,useTracking,useViewerDataEventual };
export default mod.default ?? mod;